import { get, post } from './request'

// /web *芒果平台
// /admin *蜗牛哥平台

// 登录
export const Login = p => post('/admin/api/v1/auth/login', p); 
// 发送验证码
export const Send = p => post('/admin/api/v1/sms/send', p);

// 请求我的信息
export const Center = p => post('/web/v1/user/center/show', p);

// 省市区数据
export const CityList = p => post('/admin/api/v1/public/city-list', p);


// 验证token是否有效
export const regToken = p => post('/admin/api/v1/user/check/token', p);

// *******系统设置
// 帮助分类
export const Category = p => post('/web/v1/category/index', p);
// 帮助列表
export const Article = p => post('/web/v1/article/index', p);
// 帮助详情
export const ArticleShow = p => post('/web/v1/article/show', p);
// 通知列表
export const NoticeList = p => post('/web/v1/article/notice', p);

// 认证赏金猎人----基本信息
export const BasicInfor = p => post('/web/v1/user/center/auth/create', p);

// 生成临时上传token
export const qiniuToken = p => post('/admin/api/v1/qiniu/token', p);

// 银行类型
export const banksList = p => post('/admin/api/v1/wallet/banks', p);

// 银行信息提交
export const banksCreate = p => post('/web/v1/user/center/bank/create', p);

// *******系统设置

// 注册统计
export const StatisticsNum = p => post('/web/v1/statistics/regist', p);

// 客户列表
export const CustomerList = p => post('/web/v1/user/center/customer/list', p);

// 客户详情
export const CustomerInfor = p => post('/web/v1/user/center/customer/show', p);

// 收入统计
export const FinancialStat = p => post('/web/v1/statistics/income', p);

// 收入列表
export const incomeList = p => post('/web/v1/user/center/income/list', p);

//  保险箱
export const myWallet = p => post('/web/v1/wallet', p);

//  保险箱 -- 提现列表
export const withdrawList = p => post('/web/v1/wallet/withdraw/list', p);

//  保险箱 -- 申请提现
export const applyWithdraw = p => post('/web/v1/wallet/withdraw', p);

//  保险箱 -- 申请提现详情
export const withdraDetails = p => post('/web/v1/wallet/withdraw/show', p);

//  客户详情-修改备注
export const clientMemo = p => post('/web/v1/user/center/customer/memo/edit', p);

//  客户详情-客户置顶
export const customerTop = p => post('/web/v1/user/center/customer/top', p);

// 赏金猎手-推广-海报模板列表
export const hunterTemplate = p => post('/web/v1/hunter/template/list', p);

// 赏金猎手-推广-海报上传
export const posterCreate = p => post('/web/v1/hunter/poster/create', p);

// 赏金猎手-模板列表
export const templateList = p => post('/web/v1/backend/hunter/template', p);

// 赏金猎手-模板列表-删除
export const templateDelete = p => post('/web/v1/backend/hunter/template/delete', p);

// 赏金猎手-模板添加
export const templateAdd = p => post('/web/v1/backend/hunter/template/add', p);

// 赏金猎手-模板详情
export const templateShow = p => post('/web/v1/backend/hunter/template/show', p);

// 赏金猎手-模板修改
export const templateUpdate = p => post('/web/v1/backend/hunter/template/update', p);